<script lang="ts" setup>
import { inject, computed } from 'vue';
import { CONTEXT_KEY } from './types';

defineOptions({
  name: 'CarouselIndicator',
});

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
});

const context = inject(CONTEXT_KEY);

if (!context) {
  console.error('Carousel.Indicator 必须在 Carousel.Root 组件内部使用');
}

const isCurrent = computed(() => {
  const currentPage = context?.currentPage.value ?? 0;
  const slidesPerPage = context?.slidesPerPage.value ?? 1;

  return props.index >= currentPage && props.index < (currentPage + slidesPerPage);
});

const isPlaying = computed(() => context?.isPlaying.value && isCurrent.value);

const handleClick = () => {
  context?.scrollTo(props.index, false);

  const autoplay = context?.emblaApi.value?.plugins()?.autoplay;

  if (autoplay) {
    autoplay.reset();
  }
};
</script>

<template>
  <button
    type="button"
    class="embla__indicator"
    data-scope="carousel"
    data-part="indicator"
    :data-index="props.index"
    :data-current="isCurrent ? '' : undefined"
    :data-playing="isPlaying ? '' : undefined"
    @click="handleClick"
  >
    <slot></slot>
  </button>
</template>

<style lang="scss" scoped>
</style>
